export default function Experience({ t }) {
  const renderCard = (item, idx, type) => (
    <div key={`${type}-${idx}`} className="premium-card card-animated">
      <div className="card-gradient-border"></div>
      <div className="card-icon">
        {item.icon ? (
          <img src={item.icon} alt={item.title} />
        ) : (
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
        )}
      </div>
      <h4 className="card-title">{item.title}</h4>
      <span className="card-subtitle">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '6px'}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        {item.details}
      </span>
      <p className="card-desc" style={{ whiteSpace: 'pre-line' }}>{item.desc}</p>
    </div>
  );

  return (
    <section id="experience" className="premium-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-tag">Career Path</span>
          <h3 className="section-title">{t.expTitle} & {t.volTitle}</h3>
        </div>
        <div className="premium-grid">
          {Array.isArray(t.jobs) && t.jobs.map((job, idx) => renderCard(job, idx, 'job'))}
          {Array.isArray(t.internships) && t.internships.map((internship, idx) => renderCard(internship, idx, 'internship'))}
          {Array.isArray(t.volJobs) && t.volJobs.map((vjob, idx) => (
            <div key={`vol-${idx}`} className="premium-card card-animated">
              <div className="card-gradient-border"></div>
              <div className="card-icon volunteer-icon">
                {vjob.icon ? (
                  <img src={vjob.icon} alt={vjob.title} />
                ) : (
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                )}
              </div>
              <div className="volunteer-badge">Volunteer</div>
              <h4 className="card-title">{vjob.title}</h4>
              <span className="card-subtitle">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '6px'}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                {vjob.details}
              </span>
              <p className="card-desc" style={{ whiteSpace: 'pre-line' }}>{vjob.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
